/* eslint-disable max-len */
import * as React from 'react';
import Svg, { SvgProps, G, Path, Mask, Rect } from 'react-native-svg';

export function PortugueseFlagSvg(props: SvgProps) {
  return (
    <Svg
      width={24}
      height={18}
      viewBox="0 0 24 18"
      fill="none"
      {...props}
    >
      <Mask id="mask0_634_26195" x={0} y={0} width={24} height={18}>
        <Rect width={24} height={18} fill="white" />
      </Mask>
      <G mask="url(#mask0_634_26195)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V18H24V0H0Z"
          fill="#FFB400"
        />
        <Mask id="mask1_634_26195" x={0} y={0} width={24} height={18}>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V18H24V0H0Z"
            fill="white"
          />
        </Mask>
        <G mask="url(#mask1_634_26195)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V4.5H24V0H0Z"
            fill="#C51918"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 13.5V18H24V13.5H0Z"
            fill="#C51918"
          />
          <Rect
            x={3.75586}
            y={7.70703}
            width={0.84}
            height={4.368}
            fill="#F1F9FF"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.93192 6.94922H3.41992V7.36922H3.67183V7.70523H4.67983V7.36922H4.93192V6.94922Z"
            fill="#C88A02"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.67992 12.3243H4.93192V12.7443H3.41992V12.3243H3.67192V11.9883H4.67992V12.3243Z"
            fill="#C88A02"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.17589 7.03337C4.35869 7.03337 4.37727 6.96454 4.48512 6.86174C4.56886 6.78191 4.76389 6.6829 4.76389 6.57137C4.76389 6.31622 4.50063 6.10938 4.17589 6.10938C3.85115 6.10938 3.58789 6.31622 3.58789 6.57137C3.58789 6.69563 3.7222 6.77871 3.82375 6.86174C3.93075 6.94922 4.00928 7.03337 4.17589 7.03337Z"
            fill="#AD1619"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.41992 12.7461H4.93192V13.4181C4.93192 13.4181 4.74292 13.3341 4.55392 13.3341C4.36492 13.3341 4.17592 13.4181 4.17592 13.4181C4.17592 13.4181 3.98692 13.3341 3.79792 13.3341C3.60892 13.3341 3.41992 13.4181 3.41992 13.4181V12.7461Z"
            fill="#005BBF"
          />
          <Mask
            id="mask2_634_26195"
            x={3}
            y={12}
            width={2}
            height={2}
          >
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.41992 12.7461H4.93192V13.4181C4.93192 13.4181 4.74292 13.3341 4.55392 13.3341C4.36492 13.3341 4.17592 13.4181 4.17592 13.4181C4.17592 13.4181 3.98692 13.3341 3.79792 13.3341C3.60892 13.3341 3.41992 13.4181 3.41992 13.4181V12.7461Z"
              fill="white"
            />
          </Mask>
          <G mask="url(#mask2_634_26195)">
            <Path
              d="M3.40605 13.2848L3.37305 13.2043C3.50923 13.1437 3.6459 13.1133 3.78277 13.1133C3.87121 13.1133 3.91739 13.1256 3.99589 13.1605C4.06485 13.1912 4.10059 13.2008 4.176 13.2008C4.25142 13.2008 4.28716 13.1912 4.35611 13.1605C4.43462 13.1256 4.4808 13.1133 4.56923 13.1133C4.7061 13.1133 4.84277 13.1437 4.97896 13.2043L4.94596 13.2848C4.81999 13.2287 4.69451 13.2008 4.56923 13.2008C4.49382 13.2008 4.45807 13.2103 4.38912 13.241C4.31061 13.276 4.26443 13.2883 4.176 13.2883C4.08757 13.2883 4.04139 13.276 3.96289 13.241C3.89393 13.2103 3.85819 13.2008 3.78277 13.2008C3.6575 13.2008 3.53202 13.2287 3.40605 13.2848Z"
              fill="white"
            />
            <Path
              d="M3.40605 13.0348L3.37305 12.9543C3.50923 12.8937 3.6459 12.8633 3.78277 12.8633C3.87121 12.8633 3.91739 12.8756 3.99589 12.9105C4.06485 12.9412 4.10059 12.9508 4.176 12.9508C4.25142 12.9508 4.28716 12.9412 4.35611 12.9105C4.43462 12.8756 4.4808 12.8633 4.56923 12.8633C4.7061 12.8633 4.84277 12.8937 4.97896 12.9543L4.94596 13.0348C4.81999 12.9787 4.69451 12.9508 4.56923 12.9508C4.49382 12.9508 4.45807 12.9603 4.38912 12.991C4.31061 13.026 4.26443 13.0383 4.176 13.0383C4.08757 13.0383 4.04139 13.026 3.96289 12.991C3.89393 12.9603 3.85819 12.9508 3.78277 12.9508C3.6575 12.9508 3.53202 12.9787 3.40605 13.0348Z"
              fill="white"
            />
          </G>
          <Rect
            x={11.9883}
            y={7.70703}
            width={0.84}
            height={4.368}
            fill="#F1F9FF"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.1643 6.94922H11.6523V7.36922H11.9044V7.70523H12.9124V7.36922H13.1643V6.94922Z"
            fill="#C88A02"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.9123 12.3243H13.1643V12.7443H11.6523V12.3243H11.9043V11.9883H12.9123V12.3243Z"
            fill="#C88A02"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.4083 7.03337C12.5911 7.03337 12.6097 6.96454 12.7175 6.86174C12.8013 6.78191 12.9963 6.6829 12.9963 6.57137C12.9963 6.31622 12.7331 6.10938 12.4083 6.10938C12.0836 6.10938 11.8203 6.31622 11.8203 6.57137C11.8203 6.69563 11.9546 6.77871 12.0562 6.86174C12.1632 6.94922 12.2417 7.03337 12.4083 7.03337Z"
            fill="#AD1619"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6523 12.7461H13.1643V13.4181C13.1643 13.4181 12.9753 13.3341 12.7863 13.3341C12.5973 13.3341 12.4083 13.4181 12.4083 13.4181C12.4083 13.4181 12.2193 13.3341 12.0303 13.3341C11.8413 13.3341 11.6523 13.4181 11.6523 13.4181V12.7461Z"
            fill="#005BBF"
          />
          <Mask
            id="mask3_634_26195"
            x={11}
            y={12}
            width={3}
            height={2}
          >
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.6523 12.7461H13.1643V13.4181C13.1643 13.4181 12.9753 13.3341 12.7863 13.3341C12.5973 13.3341 12.4083 13.4181 12.4083 13.4181C12.4083 13.4181 12.2193 13.3341 12.0303 13.3341C11.8413 13.3341 11.6523 13.4181 11.6523 13.4181V12.7461Z"
              fill="white"
            />
          </Mask>
          <G mask="url(#mask3_634_26195)">
            <Path
              d="M11.6385 13.2848L11.6055 13.2043C11.7417 13.1437 11.8783 13.1133 12.0152 13.1133C12.1036 13.1133 12.1498 13.1256 12.2283 13.1605C12.2973 13.1912 12.333 13.2008 12.4084 13.2008C12.4838 13.2008 12.5196 13.1912 12.5885 13.1605C12.667 13.1256 12.7132 13.1133 12.8017 13.1133C12.9385 13.1133 13.0752 13.1437 13.2114 13.2043L13.1784 13.2848C13.0524 13.2287 12.9269 13.2008 12.8017 13.2008C12.7262 13.2008 12.6905 13.2103 12.6215 13.241C12.543 13.276 12.4969 13.2883 12.4084 13.2883C12.32 13.2883 12.2738 13.276 12.1953 13.241C12.1264 13.2103 12.0906 13.2008 12.0152 13.2008C11.8899 13.2008 11.7644 13.2287 11.6385 13.2848Z"
              fill="white"
            />
            <Path
              d="M11.6385 13.0348L11.6055 12.9543C11.7417 12.8937 11.8783 12.8633 12.0152 12.8633C12.1036 12.8633 12.1498 12.8756 12.2283 12.9105C12.2973 12.9412 12.333 12.9508 12.4084 12.9508C12.4838 12.9508 12.5196 12.9412 12.5885 12.9105C12.667 12.8756 12.7132 12.8633 12.8017 12.8633C12.9385 12.8633 13.0752 12.8937 13.2114 12.9543L13.1784 13.0348C13.0524 12.9787 12.9269 12.9508 12.8017 12.9508C12.7262 12.9508 12.6905 12.9603 12.6215 12.991C12.543 13.026 12.4969 13.0383 12.4084 13.0383C12.32 13.0383 12.2738 13.026 12.1953 12.991C12.1264 12.9603 12.0906 12.9508 12.0152 12.9508C11.8899 12.9508 11.7644 12.9787 11.6385 13.0348Z"
              fill="white"
            />
          </G>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.74106 11.7614C3.89251 11.5778 3.9772 11.4107 3.9772 11.2333C3.9772 11.1215 3.94391 11.0249 3.88559 10.9459L3.89544 10.9415C3.89454 10.9419 4.06158 10.8691 4.11974 10.8412C4.22785 10.7894 4.3231 10.7345 4.41597 10.6669C4.47526 10.6238 4.5547 10.5768 4.67579 10.5118L4.78962 10.4513L4.82031 10.435C4.87917 10.4036 4.923 10.3795 4.96371 10.3559C5.09059 10.2823 5.17444 10.2215 5.23856 10.1402C5.39045 9.94754 5.35892 9.68645 5.14607 9.54154C5.04179 9.47054 4.90107 9.4298 4.6948 9.39773L4.65206 9.39112L4.39978 9.352C4.30107 9.33651 4.213 9.32204 4.13447 9.30832C4.65089 9.22239 5.38832 9.25397 5.71269 9.42145L6.02099 8.82434C5.35998 8.48305 3.85388 8.5179 3.29128 8.90535C2.87863 9.18953 2.93401 9.6191 3.36335 9.80408C3.54275 9.88137 3.77662 9.93266 4.20941 10.0022C4.13688 10.0443 4.07675 10.0827 4.02073 10.1234C3.96391 10.1648 3.90304 10.1999 3.8292 10.2353C3.79389 10.2522 3.68936 10.2981 3.64142 10.3191L3.64138 10.3192L3.64138 10.3192L3.61728 10.3298C3.26757 10.4888 3.09785 10.7088 3.14856 11.1059L3.17602 11.3208L3.22526 11.336L3.74106 11.7614ZM3.30868 11.2059L3.30762 11.209L3.30843 11.2068L3.30868 11.2059ZM12.5293 11.2333C12.5293 11.4107 12.614 11.5778 12.7655 11.7614L13.2813 11.336L13.3305 11.3208L13.358 11.1059C13.4087 10.7088 13.239 10.4888 12.8893 10.3298L12.8652 10.3192L12.8651 10.3192C12.8172 10.2981 12.7127 10.2522 12.6773 10.2353C12.6035 10.1999 12.5426 10.1648 12.4858 10.1235C12.4298 10.0827 12.3697 10.0443 12.2971 10.0022C12.7299 9.93267 12.9638 9.88138 13.1432 9.80409C13.5725 9.61911 13.6279 9.18954 13.2153 8.90536C12.6527 8.51791 11.1466 8.48306 10.4856 8.82434L10.7938 9.42145C11.1182 9.25398 11.8557 9.2224 12.3721 9.30833C12.2935 9.32204 12.2055 9.33651 12.1068 9.35201L11.8543 9.39115L11.8117 9.39774C11.6055 9.4298 11.4648 9.47054 11.3605 9.54154C11.1476 9.68646 11.1161 9.94755 11.268 10.1402C11.3321 10.2215 11.416 10.2823 11.5428 10.3559C11.5835 10.3795 11.6274 10.4036 11.6862 10.435L11.717 10.4513L11.8307 10.5118C11.9518 10.5769 12.0313 10.6238 12.0906 10.6669C12.1834 10.7345 12.2787 10.7894 12.3868 10.8412C12.445 10.8691 12.612 10.9419 12.6111 10.9415L12.621 10.9459C12.5626 11.0249 12.5293 11.1215 12.5293 11.2333Z"
            fill="#AD1619"
          />
          <Path
            d="M4.44238 9.30078L4.69031 9.35207V9.72163C4.42624 9.93233 3.75586 10.2875 3.75586 10.2875V9.30078H4.44238Z"
            fill="#F1F9FF"
          />
          <Path
            d="M12.2354 9.30078L11.9874 9.35207V9.72163C12.2515 9.93233 12.9219 10.2875 12.9219 10.2875V9.30078H12.2354Z"
            fill="#F1F9FF"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0811 5.40433V5.28134C10.6491 4.97126 10.1966 4.81622 9.72374 4.81622C9.27038 4.61559 8.81149 4.53773 8.34707 4.58262C8.3472 4.58119 8.34727 4.58046 8.34727 4.58046C7.64903 4.51214 6.94536 4.81623 6.94536 4.81623C6.23608 4.81623 5.58799 5.28136 5.58799 5.28136V5.40434L6.43521 6.25524C6.43521 6.25524 6.6737 7.07428 8.34395 6.88174V6.88382C8.34395 6.88382 9.44971 6.85363 9.52741 6.82779C9.55823 6.81754 9.59021 6.8082 9.62288 6.79867C9.83946 6.73543 10.0867 6.66325 10.2339 6.25523L11.0811 5.40433ZM8.34395 4.61872C8.3202 4.8974 8.18166 6.61167 8.34395 6.8762V4.61872Z"
            fill="#AD1619"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.23428 6.11502L6.23482 6.11253L5.63867 5.55165L5.69623 5.49047L6.25564 6.01678L6.26997 5.95086C6.36147 5.97075 6.42835 5.97807 6.46733 5.97393V5.85978L6.59131 5.92687C6.65229 5.95988 6.73962 5.96875 6.85465 5.95003C6.93913 5.93629 6.99613 5.83817 7.01477 5.6291L7.05241 5.20703L7.17863 5.61153C7.23575 5.79458 7.32288 5.87527 7.44693 5.87527C7.56809 5.87527 7.61679 5.83085 7.62217 5.71889L7.63742 5.40136L7.78101 5.68498C7.83275 5.78715 7.90409 5.83351 8.00553 5.83351C8.15062 5.83351 8.24754 5.71255 8.24754 5.52277H8.25009H8.41554H8.41809C8.41809 5.71255 8.51501 5.83351 8.66009 5.83351C8.76153 5.83351 8.83288 5.78715 8.88461 5.68498L9.02821 5.40136L9.04346 5.71889C9.04883 5.83085 9.09753 5.87527 9.21869 5.87527C9.34274 5.87527 9.42988 5.79458 9.487 5.61153L9.61322 5.20703L9.65085 5.6291C9.66949 5.83817 9.7265 5.93629 9.81098 5.95003C9.926 5.96875 10.0133 5.95988 10.0743 5.92687L10.1983 5.85978V5.97393C10.2373 5.97807 10.3042 5.97075 10.3957 5.95086L10.4222 6.07307L11.0415 5.49047L11.099 5.55165L10.3285 6.27654C10.2161 6.48356 10.1595 6.6202 10.1595 6.67696C10.1595 6.76356 9.93424 6.81495 9.49454 6.86775C9.15006 6.90911 8.74352 6.93687 8.41098 6.94102V6.94155L8.36885 6.94142L8.32672 6.94155V6.94102C7.99418 6.93687 7.58763 6.90911 7.24315 6.86775C6.80346 6.81495 6.57817 6.76356 6.57817 6.67696C6.57817 6.66627 6.57616 6.65274 6.57215 6.63644C6.52765 6.5799 6.4964 6.48719 6.47563 6.40366C6.45622 6.36481 6.43405 6.3224 6.40915 6.27654L6.23843 6.11592L6.23428 6.11502ZM10.3633 6.12853C10.2257 6.1529 10.1263 6.15045 10.0736 6.10752C9.99111 6.13152 9.89441 6.13382 9.784 6.11585C9.66607 6.09666 9.58395 6.01822 9.53453 5.8881C9.47003 5.97027 9.38848 6.021 9.2908 6.03742C9.82833 6.11365 10.2049 6.22081 10.2049 6.22081C10.2049 6.22081 10.1956 6.3005 10.173 6.39416C10.1969 6.34512 10.2252 6.29062 10.258 6.23047L10.2661 6.21997L10.3633 6.12853ZM9.03704 6.00548C8.9903 5.98225 8.95299 5.94858 8.92601 5.90518C8.88594 5.94056 8.84037 5.96644 8.78976 5.98242C8.87425 5.98888 8.95687 5.99668 9.03704 6.00548ZM8.49316 5.96607C8.42779 5.93586 8.37343 5.88749 8.33281 5.82552C8.29249 5.88705 8.23862 5.93517 8.17386 5.96542C8.21221 5.96428 8.25077 5.96348 8.28952 5.96304V5.96266L8.32314 5.96276L8.35677 5.96266V5.96304C8.40251 5.96356 8.448 5.96458 8.49316 5.96607ZM6.46548 6.21421L6.38719 6.14054C6.48127 6.14989 6.55089 6.14105 6.59207 6.10752C6.67451 6.13152 6.77122 6.13382 6.88163 6.11585C6.99956 6.09666 7.08168 6.01822 7.1311 5.8881C7.19371 5.96787 7.27239 6.01801 7.36631 6.03589C6.90294 6.10099 6.55718 6.18956 6.46548 6.21421ZM7.87219 5.98124C7.79086 5.98728 7.71123 5.99458 7.6338 6.00282C7.6781 5.97971 7.71365 5.94695 7.73962 5.90518C7.77872 5.9397 7.82305 5.96518 7.87219 5.98124ZM9.93863 6.67861C9.99752 6.70617 10.0447 6.67866 10.082 6.62587C10.0788 6.64046 10.0768 6.65365 10.0759 6.66546C10.071 6.66869 10.0635 6.67257 10.0535 6.67674C10.0259 6.68837 9.98362 6.70077 9.92865 6.71331C9.8206 6.73796 9.6668 6.76246 9.48453 6.78435C9.12858 6.82708 8.70533 6.85521 8.36885 6.85741C8.03237 6.85521 7.60912 6.82708 7.25317 6.78435C7.07089 6.76246 6.91709 6.73796 6.80904 6.71331C6.76294 6.70279 6.72578 6.69238 6.69867 6.68243C6.70164 6.6813 6.70463 6.68003 6.70766 6.67861C6.89117 6.59274 8.10477 6.51216 8.32314 6.49827C8.54152 6.51216 9.75512 6.59274 9.93863 6.67861ZM10.17 6.66323L10.1687 6.6647L10.1695 6.66363L10.17 6.66323Z"
            fill="#C88A02"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.33403 4.01181C8.47321 4.01181 8.58603 3.89899 8.58603 3.75981C8.58603 3.62064 8.47321 3.50781 8.33403 3.50781C8.19486 3.50781 8.08203 3.62064 8.08203 3.75981C8.08203 3.89899 8.19486 4.01181 8.33403 4.01181Z"
            fill="#005BBF"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.16868 5.24722C8.17405 5.27485 8.18243 5.30058 8.19303 5.32351C8.16052 5.31112 8.12196 5.30395 8.08061 5.30395C7.96463 5.30395 7.87061 5.36036 7.87061 5.42995C7.87061 5.49954 7.96463 5.55595 8.08061 5.55595C8.19453 5.55595 8.28727 5.50152 8.29052 5.43363C8.29377 5.50152 8.3865 5.55595 8.50043 5.55595C8.61641 5.55595 8.71043 5.49954 8.71043 5.42995C8.71043 5.36036 8.61641 5.30395 8.50043 5.30395C8.47123 5.30395 8.44343 5.30752 8.41817 5.31398C8.42426 5.27954 8.424 5.24003 8.41605 5.19914C8.39392 5.08529 8.3206 5.00376 8.25229 5.01704C8.18398 5.03032 8.14655 5.13338 8.16868 5.24722ZM8.29052 5.42627L8.29051 5.42616L8.29052 5.42616L8.29052 5.42627ZM6.93332 5.40765C6.9227 5.38469 6.91429 5.35892 6.90891 5.33123C6.88678 5.21738 6.92422 5.11433 6.99253 5.10105C7.06084 5.08777 7.13415 5.1693 7.15628 5.28315C7.16423 5.32404 7.16449 5.36354 7.1584 5.39799C7.18366 5.39153 7.21147 5.38796 7.24066 5.38796C7.35664 5.38796 7.45066 5.44437 7.45066 5.51396C7.45066 5.58355 7.35664 5.63996 7.24066 5.63996C7.12468 5.63996 7.03066 5.58355 7.03066 5.51396L7.03076 5.51017L7.03045 5.51006L7.03055 5.51396C7.03055 5.58355 6.93653 5.63996 6.82055 5.63996C6.70457 5.63996 6.61055 5.58355 6.61055 5.51396C6.61055 5.44437 6.70457 5.38796 6.82055 5.38796C6.86205 5.38796 6.90075 5.39518 6.93332 5.40765ZM9.5639 5.48436C9.55422 5.55327 9.45326 5.59604 9.33841 5.5799C9.22356 5.56376 9.13831 5.49481 9.14799 5.4259C9.15768 5.35699 9.25863 5.31421 9.37348 5.33036C9.4146 5.33613 9.45192 5.34868 9.48246 5.36557C9.47512 5.34134 9.47038 5.31464 9.46891 5.28647C9.46284 5.17065 9.51425 5.0738 9.58374 5.07016C9.65324 5.06652 9.71449 5.15746 9.72056 5.27328C9.72274 5.31489 9.7175 5.35405 9.70667 5.38732C9.73258 5.38445 9.7606 5.38478 9.7895 5.38884C9.90435 5.40498 9.9896 5.47393 9.97992 5.54284C9.97023 5.61175 9.86928 5.65453 9.75443 5.63839C9.63958 5.62225 9.55432 5.5533 9.56401 5.48439L9.56463 5.48061L9.56435 5.48046L9.5639 5.48436ZM10.3638 5.81756C10.4662 5.87201 10.5757 5.86634 10.6084 5.8049L10.6101 5.80143C10.6202 5.81212 10.6321 5.8199 10.6458 5.82407C10.7123 5.84441 10.7938 5.771 10.8277 5.66008C10.8616 5.54917 10.8351 5.44277 10.7686 5.42242C10.702 5.40207 10.6206 5.47549 10.5867 5.58641C10.5784 5.61336 10.5738 5.64005 10.5724 5.66531C10.5495 5.63903 10.5187 5.61452 10.4821 5.59506C10.3797 5.54061 10.2702 5.54628 10.2375 5.60772C10.2049 5.66916 10.2614 5.76311 10.3638 5.81756ZM6.24226 5.8433C6.13986 5.89775 6.03036 5.89208 5.99769 5.83064C5.99708 5.8295 5.99651 5.82834 5.99596 5.82718C5.98587 5.83787 5.97392 5.84564 5.96028 5.84981C5.89374 5.87016 5.8123 5.79674 5.77839 5.68583C5.74448 5.57492 5.77094 5.46851 5.83749 5.44816C5.90403 5.42782 5.98547 5.50124 6.01938 5.61215C6.02762 5.63911 6.0323 5.6658 6.0337 5.69105C6.0566 5.66478 6.08735 5.64027 6.12396 5.6208C6.22636 5.56635 6.33586 5.57202 6.36853 5.63346C6.4012 5.6949 6.34467 5.78885 6.24226 5.8433Z"
            fill="#C88A02"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.23906 3.05859H8.41406V3.16915H8.52851V3.34415H8.41406V3.69415H8.52851V3.86915H8.12305V3.69415H8.23906V3.34415H8.12305V3.16915H8.23906V3.05859Z"
            fill="#C88A02"
          />
          <Rect
            x={8.20703}
            y={4.00781}
            width={0.336}
            height={1.092}
            fill="#C88A02"
          />
          <Path
            d="M6.85465 4.19248L6.85318 4.27646C6.10836 4.26346 5.68112 4.37215 5.57266 4.58879C5.46054 4.81276 5.48139 5.08503 5.6385 5.40845L5.56294 5.44515C5.39531 5.10008 5.37242 4.80114 5.49755 4.55119C5.62635 4.29391 6.07832 4.17892 6.85465 4.19248Z"
            fill="white"
          />
          <Path
            d="M6.99934 4.93742L6.95628 5.00954C6.79407 4.91269 6.71289 4.74741 6.71289 4.51963C6.71289 4.19227 6.88152 4.00031 7.25454 3.86894C7.4926 3.7851 7.81781 3.81947 8.23108 3.96931L8.20244 4.04828C7.80572 3.90444 7.49875 3.87199 7.28244 3.94817C6.9403 4.06866 6.79689 4.23192 6.79689 4.51963C6.79689 4.71952 6.86432 4.8568 6.99934 4.93742Z"
            fill="white"
          />
          <Path
            d="M5.74535 5.28044L5.58684 5.33611C5.42238 4.86785 5.46935 4.54984 5.75037 4.41266C5.99799 4.29178 6.35888 4.24259 6.83483 4.26188L6.82802 4.42974C6.3774 4.41148 6.04215 4.45718 5.82406 4.56363C5.63938 4.65379 5.6056 4.88253 5.74535 5.28044Z"
            fill="#C88A02"
          />
          <Path
            d="M7.59719 4.08206C7.21308 4.08206 7.05534 4.17561 6.96523 4.45183C6.9078 4.62785 6.9635 4.77809 7.14409 4.91833L7.04105 5.05102C6.80725 4.86946 6.72481 4.6471 6.80551 4.39972C6.92036 4.04771 7.1457 3.91406 7.59719 3.91406C7.8931 3.91406 8.12361 3.99181 8.28412 4.15003L8.30915 4.1747V4.98467H8.14115V4.24651C8.0158 4.13762 7.83573 4.08206 7.59719 4.08206Z"
            fill="#C88A02"
          />
          <Path
            d="M9.78598 4.27841L9.78744 4.3624C10.5323 4.3494 10.9595 4.45809 11.068 4.67473C11.1801 4.8987 11.1592 5.17097 11.0021 5.49439L11.0777 5.53109C11.2453 5.18602 11.2682 4.88707 11.1431 4.63713C11.0143 4.37985 10.5623 4.26486 9.78598 4.27841Z"
            fill="white"
          />
          <Path
            d="M9.52215 4.95305L9.56521 5.02517C9.72741 4.92832 9.80859 4.76304 9.80859 4.53526C9.80859 4.2079 9.63996 4.01593 9.26695 3.88456C9.02888 3.80072 8.70367 3.8351 8.29041 3.98493L8.31904 4.0639C8.71577 3.92006 9.02274 3.88762 9.23904 3.96379C9.58118 4.08429 9.72459 4.24754 9.72459 4.53526C9.72459 4.73514 9.65716 4.87243 9.52215 4.95305Z"
            fill="white"
          />
          <Path
            d="M10.948 5.36247L11.1065 5.41814C11.271 4.94988 11.224 4.63187 10.943 4.49469C10.6954 4.37381 10.3345 4.32462 9.85853 4.34391L9.86534 4.51177C10.316 4.49351 10.6512 4.53921 10.8693 4.64566C11.054 4.73582 11.0878 4.96456 10.948 5.36247Z"
            fill="#C88A02"
          />
          <Path
            d="M9.08641 4.09378C9.47052 4.09378 9.62825 4.18733 9.71836 4.46355C9.77579 4.63957 9.7201 4.78981 9.5395 4.93005L9.64254 5.06274C9.87635 4.88118 9.95878 4.65882 9.87808 4.41144C9.76324 4.05943 9.53789 3.92578 9.08641 3.92578C8.7905 3.92578 8.55998 4.00352 8.39947 4.16175L8.37444 4.18642V4.99639H8.54244V4.25822C8.6678 4.14934 8.84786 4.09378 9.08641 4.09378Z"
            fill="#C88A02"
          />
          <Path
            opacity={0.3}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.60352 6.94922H11.0635V11.8548C11.0635 11.8548 10.6579 13.5012 8.33352 13.5012C6.0091 13.5012 5.60352 11.8114 5.60352 11.8114V6.94922Z"
            fill="#E1E5E8"
          />
          <Mask id="mask4_634_26195" x={5} y={6} width={7} height={8}>
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.60352 6.94922H11.0635V11.8548C11.0635 11.8548 10.6579 13.5012 8.33352 13.5012C6.0091 13.5012 5.60352 11.8114 5.60352 11.8114V6.94922Z"
              fill="white"
            />
          </Mask>
          <G mask="url(#mask4_634_26195)">
            <Rect
              x={5.60352}
              y={9.97266}
              width={2.772}
              height={3.276}
              fill="#FFC034"
            />
            <Rect
              x={5.93945}
              y={10.1406}
              width={0.336}
              height={3.108}
              fill="#AD1619"
            />
            <Rect
              x={7.11523}
              y={10.1406}
              width={0.336}
              height={3.108}
              fill="#AD1619"
            />
            <Rect
              x={6.52734}
              y={10.1406}
              width={0.336}
              height={3.108}
              fill="#AD1619"
            />
            <Rect
              x={7.70312}
              y={10.1406}
              width={0.336}
              height={3.108}
              fill="#AD1619"
            />
            <Rect
              x={5.60352}
              y={6.86328}
              width={2.772}
              height={3.192}
              fill="#AD1619"
            />
            <Rect
              x={8.29102}
              y={9.89062}
              width={2.772}
              height={3.192}
              fill="#AD1619"
            />
            <Rect
              x={8.29102}
              y={6.94922}
              width={2.94}
              height={3.108}
              fill="#F1F9FF"
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.77939 7.20311H7.03139V7.90001H7.19951V7.55156H7.45151V7.90001H7.70341V8.33557H7.45136V9.11957H7.70341V9.55512H6.19141V9.11957H6.44336V8.33557H6.19141V7.90001H6.35928V7.55156H6.61128V7.90001H6.77939V7.20311Z"
              fill="#C88A02"
            />
            <Path
              d="M9.73438 7.34821L9.9064 7.16406L10.2676 7.50143L10.0955 7.68558L9.73438 7.34821Z"
              fill="#C88A02"
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.7699 12.1047V10.2656H8.66992V12.0893L8.67325 12.1035C8.77956 12.5565 9.14158 12.7856 9.71992 12.7856C10.2977 12.7856 10.6597 12.5624 10.7664 12.1192L10.7699 12.1047ZM9.71978 12.5336C9.25575 12.5336 9.00234 12.3773 8.92178 12.0596V10.5176H10.5178V12.0742C10.4374 12.3815 10.184 12.5336 9.71978 12.5336Z"
              fill="#FFC034"
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.80688 10.4219H9.63188V11.2556L8.94198 10.5053L8.81831 10.619L9.4422 11.2975H8.8769V11.5495H9.31113H9.45599L8.81836 12.243L8.94203 12.3568L9.63188 11.6065V12.581H9.80688V11.6942L10.4161 12.3568L10.5397 12.243L9.90212 11.5495H10.6138V11.2975H9.91591L10.5398 10.619L10.4161 10.5053L9.80688 11.1679V10.4219Z"
              fill="#FFC034"
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.1109 13.0818C10.1109 13.0818 8.33175 13.2217 8.33175 12.0742C8.33175 12.0742 8.31478 13.0818 6.45703 13.0818V13.9877H10.1109V13.0818Z"
              fill="#F1F9FF"
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.33312 10.6448C8.68106 10.6448 8.96312 10.3439 8.96312 9.97278C8.96312 9.60165 8.68106 9.30078 8.33312 9.30078C7.98519 9.30078 7.70312 9.60165 7.70312 9.97278C7.70312 10.3439 7.98519 10.6448 8.33312 10.6448Z"
              fill="#005BBF"
              stroke="#AD1619"
              strokeWidth={0.729167}
            />
          </G>
        </G>
      </G>
    </Svg>
  );
}
